module.exports = __webpack_public_path__ + "media/images/icon_list/icon_notification_mention-08aca0a816e5359122058d7a0f58aad6.svg";